import { Card } from "@mui/material";
import { styled } from "@mui/material/styles";

const styledName = "Tag";

export const StyledTag = styled(Card, { name: styledName })({
  "&": {
    fontSize: "1.6rem",
    padding: "5px 10px",
    width: "fit-content",
    borderRadius: "10px",
    border: "solid 1px",
  },
});
